import ScaledBackgroundMaterial from "../material-scaled-backround";
import RenderManager from "../render-manager";

class BackgroundPass extends THREE.Pass {
    constructor(camera, background, width, height) {
        super();

        this._background = background;

        this.camera = camera;

        this.needsSwap = true;

        this._material = new ScaledBackgroundMaterial();
        this._materialBackground = new ScaledBackgroundMaterial();
        this._materialBackground.transparent = true;

        const plane = new THREE.PlaneGeometry(2, 2);

        this._quadScene = new THREE.Scene();
        this._quad = new THREE.Mesh(plane, this._material);
        this._quadBackground = new THREE.Mesh(plane, this._materialBackground);
        this._quadScene.add(this._quad, this._quadBackground);
        this._quad.frustumCulled = false;
        this._quadBackground.frustumCulled = false;

        this._rt = new THREE.WebGLRenderTarget(width, height);

        this._state = { enabled: false };
    }

    setBackgroundState(state) { this._state = state; }

    setSize(width, height) {
        this._rt.setSize(width, height);
    }

    render(renderer, writeBuffer, readBuffer, delta, maskActive) {
        this._materialBackground.uniforms.viewport.value.set(0, 0, 1, 1);

        const wasVisible = this._background.visible;
        this._background.visible = true;

        renderer.render(this._background, this.camera, this._rt, true);

        this._material.setMap(this._rt);
        this._materialBackground.setMap(readBuffer.texture);
        renderer.render(this._quadScene, this.camera, writeBuffer, true);

        this._background.visible = wasVisible;
    }
}

class BackgroundRestoreStatePass extends THREE.Pass {
    constructor() {
        super();

        this._state = { enabled: false };
        this.needsSwap = false;
    }

    setBackgroundState(state) { this._state = state; }

    render() { }
}

export { BackgroundPass, BackgroundRestoreStatePass };